import React from 'react';
import { WithTranslation } from 'next-i18next';

import FlexGrid from 'components/FlexGrid';
import H3 from 'components/typo/Heading/H3';
import { withTranslation } from 'lib/i18n';

const sections = [
  'manufacturers',
  'shops',
  'services',
  'sport',
  'institutions',
  'other',
];
const base = 'business.organizations.index.purpose.targets';

const OrganizationsPurpose: React.FC<WithTranslation> = props => (
  <FlexGrid itemsPerRow={2}>
    <>
      {sections.map(section => (
        <div key={section} style={{ padding: '0 24px' }}>
          <H3 css="margin: 24px 0 0 0">
            {props.t(`${base}.${section}.title`)}
          </H3>
          <p>{props.t(`${base}.${section}.text`)}</p>
        </div>
      ))}
    </>
  </FlexGrid>
);

export default withTranslation('pages')(OrganizationsPurpose);
